import { ConfigMenuItem } from "../Stores/Config";
import { useTicketStore } from "../Stores/Ticket";

/** Home menu items whose click starts a conversation with Kai (Settings → Widget → Home → "Pass to agent"). */
export const PASS_TO_AGENT_ACTION = "PASS_TO_AGENT";

export const isPassToAgentItem = (menuItem?: ConfigMenuItem): boolean =>
  menuItem?.actionType === PASS_TO_AGENT_ACTION;

/**
 * Starts Kai exactly as the home screen's "ask Kai" composer does, with the
 * button's title (as shown, in the widget language) as the customer's first
 * message. The project's own workflow picks the conversation up (Kai answers
 * it, or the team when no workflow answers). The item's extra instructions
 * for Kai stay on the server: the widget only passes their key.
 */
export const startPassToAgent = (menuItem: ConfigMenuItem) => {
  const title = typeof menuItem.title === "string" ? menuItem.title.trim() : "";
  useTicketStore.getState().createNewConversation(
    {
      aiQuestion: !!title,
      isManualStart: true,
      ...(menuItem.kaiInstructionsKey
        ? { kaiInstructionsKey: menuItem.kaiInstructionsKey }
        : {}),
    },
    title || undefined,
  );
};
